// src/api/tenant/stock.api.js
import apiClient from "../client";

const extractData = (response) => {
  if (response?.data?.data?.data && Array.isArray(response.data.data.data)) {
    return response.data.data.data;
  }
  if (response?.data?.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  if (response?.data && Array.isArray(response.data)) {
    return response.data;
  }
  if (Array.isArray(response)) {
    return response;
  }
  return [];
};

const extractSingle = (response) => {
  if (response?.data?.data) {
    return response.data.data;
  }
  if (response?.data) {
    return response.data;
  }
  return response;
};

export const stockApi = {
  // Stock CRUD
  getSummary: (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    return apiClient.get(`/stock${params.toString() ? `?${params.toString()}` : ''}`);
  },

  getDashboardStats: () => apiClient.get('/stock/dashboard-stats'),

  getById: (id) => apiClient.get(`/stock/${id}`),

  getByType: (type) => apiClient.get(`/stock/type/${type}`),

  create: (data) => apiClient.post('/stock', data),

  update: (id, data) => apiClient.put(`/stock/${id}`, data),

  delete: (id) => apiClient.delete(`/stock/${id}`),

  // Stock Actions
  performAction: (data) => apiClient.post('/stock/action', data),

  // Transactions
  getTransactions: (stockId, filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    return apiClient.get(`/stock/${stockId}/transactions${params.toString() ? `?${params.toString()}` : ''}`);
  },

  // Alerts
  getLowStockAlerts: () => apiClient.get('/stock/alerts/low-stock'),

  getExpiryAlerts: () => apiClient.get('/stock/alerts/expiry'),
};

export default stockApi;